@if (isLoading) {
<kzn-loader message="Getting request details..."></kzn-loader>
} @else if (isError) {
<kzn-status-message heading="Something wrong happened" message="Not able to download request details. Please try again."
  [isSuccess]="false"></kzn-status-message>
} @else {
<div class="create-sign-stepper create-sign-stepper--hide-mat-headers"
  [class.on-review]="stepper?.selectedIndex === 1"
  [class.self-sign-review]="selfSignMode && stepper?.selectedIndex === 1"
  [class.self-sign-complete-step]="stepper?.selectedIndex === 2 && !!selfSignCompleteResult">
  <div class="create-sign-stepper__card" #stepContentContainer>
    <mat-stepper
      linear
      #stepper
      labelPosition="bottom"
      class="create-sign-stepper__mat-stepper"
      [class.thank-you-step]="stepper?.selectedIndex === 2"
      (selectionChange)="onStepperSelectionChange($event)">

     
      <ng-template matStepperIcon="number" let-index="index">
        @if(index === 0) { <img class="step-icon-img" src="assets/upload-doc1.png" alt="Setup Document" /> }
        @else if(index === 1) { <img class="step-icon-img" src="assets/tag.png" alt="Review Document" /> }
        @else { <img class="step-icon-img" src="assets/sendiocn.png" alt="Sent" /> }
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        @if(index === 0) { <img class="step-icon-img" src="assets/upload-doc1.png" alt="Setup Document" /> }
        @else if(index === 1) { <img class="step-icon-img" src="assets/tag.png" alt="Review Document" /> }
        @else { <img class="step-icon-img" src="assets/sendiocn.png" alt="Sent" /> }
      </ng-template>
      <ng-template matStepperIcon="done" let-index="index">
        @if(index === 0) { <img class="step-icon-img" src="assets/upload-doc1.png" alt="Setup Document" /> }
        @else if(index === 1) { <img class="step-icon-img" src="assets/tag.png" alt="Review Document" /> }
        @else { <img class="step-icon-img" src="assets/sendiocn.png" alt="Sent" /> }
      </ng-template>

      @for(step of steps; track step; let index = $index) {
      <mat-step
        [completed]="index === 0 ? isPdfUploaded : false"
        [editable]="isEditable">

        <ng-template matStepLabel>
          @if(index === 0) { Setup Document }
          @else if(index === 1) { Review Document }
          @else { Sent }
        </ng-template>

        
        @if(index === 0) {
          <app-create-setup-document
            #setupDocRef
            [useCombinedSetupLayout]="false"
            [wizardSetupPhase]="wizardSetupPhase"
            [isSelfSignRequestPath]="isSelfSignRequestPath"
            (wizardSetupAdvance)="onSetupAdvance()"
            (wizardSetupGoBack)="onSetupGoBack()"
            (pdfUploaded)="handlePdfUploaded($event)"
            (appTokenUpdated)="handleAppTokenUpdated($event)"
            (selfSignSelected)="onSelfSignSelected()"
            (onReset)="resetStepper()"
            (onNext)="nextStep()">
          </app-create-setup-document>
        }

    
        @else if(index === 1) {
          <app-pdf-view-edit
            class="pdf-view-edit-step"
            [pdfFile]="pdfFile"
            [docName]="resolvedDocumentName"
            [appToken]="appToken"
            [selfSignMode]="selfSignMode"
            [fixedToolsLayout]="true"
            (previousStep)="previousStep()"
            (onSubmitComplete)="handleSubmitComplete()"
            (selfSignComplete)="handleSelfSignComplete($event)"
            [topPosition]="topPosition">
          </app-pdf-view-edit>
        }

        
        @else {
          @if (selfSignCompleteResult && stepper.selectedIndex === 2) {
            <app-pdf-self-sign-complete
              [signRequestId]="selfSignCompleteResult.signRequestId"
              [docName]="selfSignCompleteResult.docName"
              [previewFile]="pdfFile">
            </app-pdf-self-sign-complete>
          } @else if (stepper.selectedIndex === 2) {
            <app-pdf-thank-you></app-pdf-thank-you>
          }
        }

      </mat-step>
      }
    </mat-stepper>
  </div>


  @if (stepper?.selectedIndex === 1) {
  <div class="create-sign-stepper__props-backdrop"
       [class.show]="propertiesDrawerOpen"></div>
  <aside class="create-sign-stepper__props-wrapper"
       [class.drawer-open]="propertiesDrawerOpen"
       [class.create-sign-stepper__props-wrapper--self-sign]="selfSignMode">
    <div class="create-sign-stepper__props-handle"
         [class.open]="propertiesDrawerOpen"
         (click)="togglePropertiesDrawer()">
      <div class="create-sign-stepper__props-grip"></div>
      <div class="create-sign-stepper__props-title">Property</div>
      <mat-icon class="create-sign-stepper__props-icon">{{ propertiesDrawerOpen ? 'expand_more' : 'expand_less' }}</mat-icon>
    </div>

    <div class="create-sign-stepper__field-actions create-sign-stepper__review-tools-desktop">
      <button mat-stroked-button type="button" class="create-sign-stepper__field-back" (click)="goToPrevious()">
        Back
      </button>
      <button mat-flat-button type="button" color="warn" class="create-sign-stepper__field-submit" (click)="submitData()">
        Submit
      </button>
    </div>

    <div class="create-sign-stepper__props-body">
    <div class="create-sign-stepper__tools-stack create-sign-stepper__review-tools-desktop">
      <div class="create-sign-stepper__tools-card">
        <div class="create-sign-stepper__tools-inner">
          <div class="create-sign-stepper__panel-hint create-sign-stepper__tools-hint">
            <div class="create-sign-stepper__panel-hint-brand">
              <div class="circle-hint"><img src="assets/hint.png" class="hint-icon" alt="Hint"></div>
              <span class="create-sign-stepper__panel-hint-title">Tools</span>
            </div>
            <p>Choose a tool and click or drag onto the document.</p>
          </div>
          <div class="create-sign-stepper__tools-grid" [attr.data-tools-revision]="tableService.tableInputDataRevision">
            @for (tool of fieldTools; track tool.id) {
              <div
                role="button"
                tabindex="0"
                class="create-sign-stepper__tool"
                [class.create-sign-stepper__tool--active]="pdfEditState.selectedTool() === tool.id"
                [class.create-sign-stepper__tool--dragging]="pdfViewEditComponent.draggingToolId === tool.id"
                [class.create-sign-stepper__tool--disabled]="isToolDisabled(tool)"
                [attr.aria-disabled]="isToolDisabled(tool)"
                [attr.draggable]="!isToolDisabled(tool)"
                (click)="pdfViewEditComponent.onToolClick(tool.id, $event)"
                (keydown.enter)="pdfViewEditComponent.onToolClick(tool.id, $event)"
                (keydown.space)="pdfViewEditComponent.onToolClick(tool.id, $event); $event.preventDefault()"
                (dragstart)="pdfViewEditComponent.onToolDragStart($event, tool.id)"
                (dragend)="pdfViewEditComponent.onToolDragEnd()">
                <mat-icon>{{ tool.icon }}</mat-icon>
                <span>{{ tool.label }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <mat-card class="create-sign-stepper__props-panel"
      [class.drawer-open]="propertiesDrawerOpen">
      <div class="create-sign-stepper__panel-hint create-sign-stepper__props-hint-banner">
        <div class="create-sign-stepper__panel-hint-brand">
          <div class="circle-hint"><img src="assets/hint.png" class="hint-icon" alt="Hint"></div>
          <span class="create-sign-stepper__panel-hint-title">Property</span>
        </div>
        <p>Click a document field to customize its settings.</p>
      </div>
      <mat-card-content class="create-sign-stepper__props-content">
        @if (displayedPropertyAnnotation; as ann) {
        @if (!selfSignMode) {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Field Name</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <input matInput id="placeholder" #placeholderEl [ngModel]="ann.properties.placeholder"
              (input)="pdfEditState.updateAnnotationProperty('placeholder', placeholderEl.value)" />
          </mat-form-field>
        </div>
        }

        @if (!selfSignMode) {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Font Size</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select [ngModel]="ann.properties.fontSize"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('fontSize', $event)">
              @for (size of fontSizes; track size) {
              <mat-option [value]="size">{{ size }} px</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        } @else if (ann.type === 'text' || ann.type === 'initials' || ann.type === 'date') {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Font Size</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select [ngModel]="ann.properties.fontSize"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('fontSize', $event)">
              @for (size of fontSizes; track size) {
              <mat-option [value]="size">{{ size }} px</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        @if (!selfSignMode) {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Assign to</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select [ngModel]="ann.properties.user"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('user', $event)">
              @for (user of tableService.tableInputData; track user) {
              <mat-option [value]="user.email">{{ user.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        @if (!selfSignMode && (ann.type === 'text' || ann.type === 'comment' || ann.type === 'initials')) {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">{{ 'fieldColor' | translate }}</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select
              [ngModel]="ann.properties['signatureColor'] || '#000000'"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('signatureColor', $event)">
              @for (color of selfSignSignatureColors; track color.id) {
              <mat-option [value]="color.value">
                <span class="create-sign-stepper__color-option">
                  <span class="create-sign-stepper__color-dot" [style.background-color]="color.value"></span>
                  {{ color.labelKey | translate }}
                </span>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Copy to</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select placeholder="Select" (selectionChange)="pdfEditState.copyAnnotationToPages($event.value)">
              <mat-option value="all">All Pages</mat-option>
              <mat-option value="even">Even Pages</mat-option>
              <mat-option value="odd">Odd Pages</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        }
      </mat-card-content>
    </mat-card>
    </div>
  </aside>
  }
</div>
}
